import React from 'react';
import List, { Item } from 'devextreme-react/list';
import { ScrollableViewport, GridTabs } from '@ihsm/ui-shared';
import { SmallTransparentButton } from 'shared/components/Buttons';
import { FormColumnItem } from '../types';
import './ColumnsTabsSelection.scss';

interface ColumnsTabsSelectionProps {
  tabs: string[];
  selectedTab: string;
  listData: FormColumnItem[];
  selectedItems?: FormColumnItem[];
  onChangeTab: (tab: string) => void;
  onDataChange: (list: FormColumnItem[]) => void;
}

export const ColumnsTabsSelection: React.FC<ColumnsTabsSelectionProps> = ({
  selectedTab,
  tabs = [],
  listData = [],
  selectedItems = [],
  onDataChange = () => {},
  onChangeTab = () => {},
}) => (
  <div className="columns-tabs-selections">
    <div className="columns-tabs-selections__grid-area">
      <GridTabs activeTab={selectedTab} onChange={onChangeTab} tabs={tabs} />
      <div className="columns-tabs-selections__list-area">
        <ScrollableViewport vertical>
          <List
            dataSource={listData}
            selectionMode="multiple"
            keyExpr="name"
            showScrollbar="never"
            onSelectedItemsChange={onDataChange}
            selectedItems={selectedItems}
            itemRender={({ name }: FormColumnItem) => <div>{name}</div>}
          >
            <Item />
          </List>
        </ScrollableViewport>
      </div>
    </div>

    <div className="columns-tabs-selections__select-all-button">
      <SmallTransparentButton
        onClick={() => onDataChange(listData)}
        text="Select All"
      />
    </div>
  </div>
);
